<template>
  <Modal
    v-model="_value"
    width="400"
    title="ZT设置里程"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="110">
      <FormItem prop="mileage" label="行驶里程（公里）">
        <Input v-model="setDriverCardParams.mileage" placeholder="行驶里程（公里）" style="width: 220px;">
        </Input>
      </FormItem>
      <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
      <Button type="primary" @click="onSendDriverCardParams">发送</Button>
    </Form>
  </Modal>
</template>

<script>

  import Vue from 'vue'
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'


  export default {
    name: 'ztsetdrivermileagemodal',
    components: {},
    props: {
      initValue: null,
      terminalNumValue: null,
      value: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        setDriverCardParams: {
          id: null,
          mileage: '0',
        },
        //速度来源
        sourcesOptions: [
          {name: 'GPS', value: 1},
          {name: '车辆', value: 2},
          {name: '混合', value: 3},
          {name: 'CAN', value: 4},
        ],
        //报警类型
        alarmTypeOptions: [
          {name: '高速预警', value: 1},
          {name: '高速报警', value: 2},
        ],

      }
    },
    methods: {
      ...mapActions([
        'VehicleInfoServ_SearchByName'
      ]),
      visibleChange(val) {
        if (val) {
          this.setDriverCardParams.id = this._initValue
          this.setDriverCardParams.mileage = '0'
        }
      },
      onCleanDriverCardParams() {
        this.setDriverCardParams.mileage = '0'
      },
      onSendDriverCardParams() {


        if (this.setDriverCardParams.mileage == null && this.setDriverCardParams.mileage == '') {
          this.$Message.error('行驶里程不能为空')
          return
        }
        if (this.setDriverCardParams.mileage < 0 ) {
          this.$Message.error('行驶里程不能少于0')
          return
        }

        let content = '##_ZTTtsSet;速度报警设置;'
        if (this.setDriverCardParams.mileage !=null && this.setDriverCardParams.mileage != ''){
          content += '行驶里程km='+this.setDriverCardParams.mileage + ','
        }
        content = content.substring(0,content.length-1)
        content += '$'
        console.log(content)


        store.dispatch('NetCommandServ_SendCommand', {
          params: {
            id: this._initValue,
            content: content,
            urgent: false
          }
        }).then(() => {
          this.$Message.success('发送成功')
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    },
    computed: {
      _value: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _terminalNumValue: {
        get() {
          return this.terminalNumValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
